import {
  omit,
  pick,
} from 'lodash';

import {
  reverseOrder,
} from '@/helpers/products/home';

import {
  createOptions,
  monthsOptions,
  otherOption,
} from '@/helpers/common';

import {
  getRangeOfYears,
  UtcDate,
} from '@/helpers/date';

import * as commonConstants from '@/constants/common';
import * as homeConstants from '@/constants/products/home';

// step 1,3 icons
import IconHome from '!svg-inline-loader!@/assets/icons/icon-home.svg';
import IconBuilding from '!svg-inline-loader!@/assets/icons/icon-building.svg';
import IconContents from '!svg-inline-loader!@/assets/icons/icon-contents.svg';
import IconTypeHouse from '!svg-inline-loader!@/assets/icons/icon-type-house.svg';
import IconTypeApartment from '!svg-inline-loader!@/assets/icons/icon-type-apartment.svg';
import IconTypeBungalow from '!svg-inline-loader!@/assets/icons/icon-type-bungalow.svg';
import IconTypeTownHouse from '!svg-inline-loader!@/assets/icons/icon-type-town-house.svg';
import IconTypeOther from '!svg-inline-loader!@/assets/icons/icon-type-other.svg';

const constants = Object.assign(
  {},
  commonConstants,
  homeConstants,
);

const omitObj = (obj, key) => {
  const { [key]: omitted, ...rest } = obj;
  return rest;
};

export default (stepNumber) => {
  const commonOptions = {
    noYes: constants.NO_YES,
    yesNo: constants.NO_YES.slice().reverse(),
    attrsForNumKeyboard: constants.ATTRS_FOR_NUM_KEYBOARD,
  };

  switch (stepNumber) {
    case 1:
      return {
        ...commonOptions,
        IconHome,
        // constants
        HOME_PROPERTY_OWNED_FAVORITES: constants.HOME_PROPERTY_OWNED_FAVORITES,
        HOME_PROPERTY_TYPE: constants.HOME_PROPERTY_TYPE,
        HOME_PROPERTY_ROOF_MADE_FAVORITES: constants.HOME_PROPERTY_ROOF_MADE_FAVORITES,
        HOME_PROPERTY_FLAT_ROOF_FAVORITES: constants.HOME_PROPERTY_FLAT_ROOF_FAVORITES,
        HOME_PROPERTY_WALLS_MADE_FAVORITES: constants.HOME_PROPERTY_WALLS_MADE_FAVORITES,
        HOME_PROPERTY_WALLS_MADE: constants.HOME_PROPERTY_WALLS_MADE,
        COVER_PROPERTY_COVER_TYPE_RENTING: constants.COVER_PROPERTY_COVER_TYPE_RENTING,
        PROPERTY_ROOMS_MIN_QTY: constants.PROPERTY_ROOMS_MIN_QTY,
        PROPERTY_ROOMS_MAX_QTY: constants.PROPERTY_ROOMS_MAX_QTY,

        // template options
        propertyRoofMadeGeneric: [
          ...createOptions({ source: pick(constants.HOME_PROPERTY_ROOF_MADE, constants.HOME_PROPERTY_ROOF_MADE_FAVORITES) }), otherOption()],
        propertyOwnedItems: [...createOptions({ source: pick(constants.HOME_PROPERTY_OWNED, constants.HOME_PROPERTY_OWNED_FAVORITES) }), otherOption()],
        propertyRoofMadeOther: createOptions({ source: omit(constants.HOME_PROPERTY_ROOF_MADE, constants.HOME_PROPERTY_ROOF_MADE_FAVORITES) }),
        propertyOwnedOther: createOptions({ source: omit(constants.HOME_PROPERTY_OWNED, constants.HOME_PROPERTY_OWNED_FAVORITES) }),
        propertyWallsMadeItemsOther: createOptions({ source: omit(constants.HOME_PROPERTY_WALLS_MADE, constants.HOME_PROPERTY_WALLS_MADE_FAVORITES) }),
        propertyWallsMadeItems: [...createOptions({
          source: pick(constants.HOME_PROPERTY_WALLS_MADE,
            constants.HOME_PROPERTY_WALLS_MADE_FAVORITES),
        }), otherOption()],
        propertyFloorItems: createOptions({ source: constants.HOME_PROPERTY_FLOOR }),
        propertyFlatRoofItemsOther: createOptions({ source: omit(constants.HOME_PROPERTY_FLAT_ROOF, constants.HOME_PROPERTY_FLAT_ROOF_FAVORITES), asNumbers: true }),
        propertyNearestRiverItems: createOptions({ source: constants.HOME_PROPERTY_NEAREST_RIVER, asNumbers: true }),
        propertyListedItems: createOptions({ source: constants.HOME_PROPERTY_LISTED }),
        propertyMainResidenceItems: createOptions({ source: constants.HOME_PROPERTY_MAIN_RESIDENCE }),
        propertyCoverTypeItems: (() => {
          const types = createOptions({ source: constants.COVER_PROPERTY_COVER_TYPE });
          types.forEach(option => {
            if (option.value === 'B') {
              option.icon = IconBuilding;
              option.iconType = 'component';
            }
            if (option.value === 'BC') {
              option.icon = [IconBuilding, IconContents];
              option.iconType = 'component';
            }
            if (option.value === 'C') {
              option.icon = IconContents;
              option.iconType = 'component';
            }
          });
          return types;
        })(),
        propertySortItems: (() => {
          const options = createOptions({ source: constants.HOME_PROPERTY_SORT });
          options.forEach(option => {
            if (option.value === 'H') {
              option.icon = IconTypeHouse;
              option.iconType = 'component';
            }
            if (option.value === 'A') {
              option.icon = IconTypeApartment;
              option.iconType = 'component';
            }
            if (option.value === 'B') {
              option.icon = IconTypeBungalow;
              option.iconType = 'component';
            }
            if (option.value === 'T') {
              option.icon = IconTypeTownHouse;
              option.iconType = 'component';
            }
            if (option.value === 'O') {
              option.icon = IconTypeOther;
              option.iconType = 'component';
            }
          });
          return options;
        })(),
      };
    case 2:
      return {
        ...commonOptions,
        months: monthsOptions,

        // constants
        COVER_PROPERTY_SPECIFIC_ITEMS: constants.COVER_PROPERTY_SPECIFIC_ITEMS,
        COVER_ITEMS_MAX_AMOUNT: constants.COVER_ITEMS_MAX_AMOUNT,
        PROPERTY_PURCHASED_MIN_YEARS: constants.PROPERTY_PURCHASED_MIN_YEARS,
        HOME_PROPERTY_UNOCCUPIED_DAYS_FAVORITE: constants.HOME_PROPERTY_UNOCCUPIED_DAYS_FAVORITE,
        HOME_PROPERTY_BUSINESS_TYPE_FAVORITE: constants.HOME_PROPERTY_BUSINESS_TYPE_FAVORITE,
        HOME_PROPERTY_PATIODOR_LOCK_FAVORITE: constants.HOME_PROPERTY_PATIODOR_LOCK_FAVORITE,
        HOME_PROPERTY_EXTERNALDOR_LOCK_FAVORITE: constants.HOME_PROPERTY_EXTERNALDOR_LOCK_FAVORITE,
        HOME_PROPERTY_WALLS_MADE: constants.HOME_PROPERTY_WALLS_MADE,
        HOME_PROPERTY_ROOF_MADE: constants.HOME_PROPERTY_ROOF_MADE,

        // locks
        LOCK_ANIMATIONS: constants.LOCK_ANIMATIONS,
        homePropertyMaindorLocks: constants.HOME_PROPERTY_MAINDOR_LOCK,
        homePropertyPatiodorLocks: omitObj(constants.HOME_PROPERTY_PATIODOR_LOCK, constants.HOME_PROPERTY_PATIODOR_LOCK_FAVORITE),
        propertyExternaldorLocks: omitObj(constants.HOME_PROPERTY_EXTERNALDOR_LOCK, constants.HOME_PROPERTY_EXTERNALDOR_LOCK_FAVORITE),

        // template options
        propertySpecificItemsItemItems: createOptions({ source: constants.COVER_PROPERTY_SPECIFIC_ITEMS }),
        allRisksUnspecifiedItems: createOptions({ source: omit(constants.COVER_ALL_RISKS_UNSPECIFIED, constants.COVER_ALL_RISKS_UNSPECIFIED_FAVORITES), asNumbers: true }),
        propertyBicycleOrLaptopItems: createOptions({ source: constants.COVER_PROPERTY_BICYCLE_OR_LAPTOP }),
        propertyOccupiedItems: createOptions({ source: constants.HOME_PROPERTY_OCCUPIED }),
        propertyUnoccupiedDaysItems: [...createOptions({ source: pick(constants.HOME_PROPERTY_UNOCCUPIED_DAYS, constants.HOME_PROPERTY_UNOCCUPIED_DAYS_FAVORITE), asNumbers: true }), otherOption(false, 'More Than 14 Days in a Row')],
        propertyUnoccupiedDaysItemsOther: createOptions({
          source: omit(constants.HOME_PROPERTY_UNOCCUPIED_DAYS,
            constants.HOME_PROPERTY_UNOCCUPIED_DAYS_FAVORITE),
          asNumbers: true,
        }),
        propertyBusinessTypeItems: createOptions({ source: omit(constants.HOME_PROPERTY_BUSINESS_TYPE, constants.HOME_PROPERTY_BUSINESS_TYPE_FAVORITE) }),
        propertyTotalSmokeAlarmsItems: createOptions({ source: constants.HOME_PROPERTY_TOTAL_SMOKE_ALARMS, asNumbers: true }),
        propertyLocalWatchItems: createOptions({ source: constants.HOME_PROPERTY_LOCAL_WATCH }),
        propertyUnoccupiedItems: createOptions({ source: constants.HOME_PROPERTY_UNOCCUPIED }),
      };
    case 3:
      return {
        ...commonOptions,
        IconHome,
        months: monthsOptions,

        // constants
        CLAIMS_MAX_QTY: constants.CLAIMS_MAX_QTY,
        MARITAL_STATUS: constants.MARITAL_STATUS,
        INSURED_EMPLOYMENT_STATUS: constants.INSURED_EMPLOYMENT_STATUS,
        INSURED_MARITAL_STATUS_FAVORITES: constants.INSURED_MARITAL_STATUS_FAVORITES,
        INSURED_EMPLOYMENT_STATUS_FAVORITES: constants.INSURED_EMPLOYMENT_STATUS_FAVORITES,
        INSURED_ADDITIONAL_RELATIONSHIP_PROPOSER_FAVORITES: constants.INSURED_ADDITIONAL_RELATIONSHIP_PROPOSER_FAVORITES,
        CLAIM_CAUSE: constants.CLAIM_CAUSE,
        CLAIM_STATUS: constants.CLAIM_STATUS,
        CLAIM_PROPERTY_CLAIM_TYPE: constants.CLAIM_PROPERTY_CLAIM_TYPE,
        INSURED_EMPLOYMENT_STATUS_BUSINESS: constants.INSURED_EMPLOYMENT_STATUS_BUSINESS,
        INSURED_EMPLOYMENT_STATUS_EDUCATION: constants.INSURED_EMPLOYMENT_STATUS_EDUCATION,
        INSURED_ADDITIONAL_RELATIONSHIP_PROPOSER: constants.INSURED_ADDITIONAL_RELATIONSHIP_PROPOSER,

        // template options
        title: createOptions({ source: constants.INSURED_TITLE }),
        dateOfBirthYearItems: (() => {
          const maxDateOfBirth = new UtcDate().subYears(constants.INSURER_MIN_AGE);
          const end = maxDateOfBirth.getFullYear();
          const start = constants.INSURER_MAX_AGE - constants.INSURER_MIN_AGE;
          return getRangeOfYears(start, end);
        })(),
        martialStatusItems: [...createOptions({ source: pick(constants.MARITAL_STATUS, constants.INSURED_MARITAL_STATUS_FAVORITES) }), otherOption()],
        martialStatusItemsOther: createOptions({ source: omit(constants.MARITAL_STATUS, constants.INSURED_MARITAL_STATUS_FAVORITES) }),
        employmentStatusItems: [...createOptions({ source: pick(constants.INSURED_EMPLOYMENT_STATUS, constants.INSURED_EMPLOYMENT_STATUS_FAVORITES) }), otherOption()],
        employmentStatusItemsOther: createOptions({ source: omit(constants.INSURED_EMPLOYMENT_STATUS, constants.INSURED_EMPLOYMENT_STATUS_FAVORITES) }),
        relationshipProposerItems: [...createOptions({ source: pick(constants.INSURED_ADDITIONAL_RELATIONSHIP_PROPOSER, constants.INSURED_ADDITIONAL_RELATIONSHIP_PROPOSER_FAVORITES) }), otherOption()],
        relationshipProposerItemsOther: createOptions({ source: omit(constants.INSURED_ADDITIONAL_RELATIONSHIP_PROPOSER, constants.INSURED_ADDITIONAL_RELATIONSHIP_PROPOSER_FAVORITES) }),
        occupantsConvictionsItems: createOptions({ source: constants.COVER_OCCUPANTS_CONVICTIONS }),
        propertyPaymentTypeItems: createOptions({ source: constants.COVER_PROPERTY_PAYMENT_TYPE }),
        buildNoClaimsBonusItems: createOptions({ source: constants.COVER_BUILDING_NO_CLAIMS_BONUS, asNumbers: true }),
        contentsNoClaimsBonusItems: createOptions({ source: constants.COVER_CONTENTS_NO_CLAIMS_BONUS, asNumbers: true }),
        buildVoluntaryExcessItems: reverseOrder(createOptions({ source: constants.COVER_BUILD_VOLUNTARY_EXCESS, asNumbers: true })),
        contentsVoluntaryExcessItems: reverseOrder(createOptions({ source: constants.COVER_BUILD_VOLUNTARY_EXCESS, asNumbers: true })),
        propertyClaimTypeItems: createOptions({ source: constants.CLAIM_PROPERTY_CLAIM_TYPE }),
        claimCauseItems: createOptions({ source: constants.CLAIM_CAUSE }),
        claimStatusItems: createOptions({ source: constants.CLAIM_STATUS }),
      };
  }
};
